module.exports = __webpack_public_path__ + "static/media/zinnia-kwan.353248be.png";